/* drowsie-aura.js — the breathing ground, shared by every layout:none page (MN 2026-09-23).
   Five violet blobs + a dusky rose drift, swell and merge (screen blend) behind the whole page.
   Transform-only keyframes on composited layers: no blur, no scroll JS, cheap on a phone.

   It sits at z-index:-1 in the ROOT stacking context: html carries the base colour, body is made
   transparent, so the light paints above the base and below every section without touching any
   page's own z-indexes. A page only needs:  <script src="{{ 'drowsie-aura.js' | asset_url }}" defer></script>
   Its own static glows (body or section radial-gradients) should come off, or they double up.

   09-24: every strength ×0.7 (MN: "dim those background circles everywhere by 30%").
   REVERT (all pages at once): set ENABLED = false, push this file, then re-push the templates
   (their cached HTML holds the old ?v=).  Compare on any page with ?aura=off. */
(function () {
  'use strict';
  var ENABLED = true;
  if (!ENABLED || window.__dzAura || /[?&]aura=off\b/.test(location.search)) return;
  window.__dzAura = 1;

  var BASE = '#0B0A14';
  var css = [
    'html{background:' + BASE + '}',
    'body{background-color:transparent!important;background-image:none!important}',
    '.dz-aura{position:fixed;inset:0;z-index:-1;pointer-events:none;overflow:hidden;isolation:isolate;contain:strict}',
    '.dz-aura i{position:absolute;left:50%;top:50%;border-radius:50%;mix-blend-mode:screen;will-change:transform;',
    '  animation:var(--k) var(--d) ease-in-out infinite alternate;',
    '  background:radial-gradient(closest-side,var(--c) 0%,var(--c) 22%,rgba(0,0,0,0) 74%)}',
    // sizes, speeds and strengths are howitworks v4 as MN approved it on 09-23
    '.dz-aura .a1{width:115vmax;height:95vmax;margin:-47.5vmax 0 0 -57.5vmax;--c:rgba(96,36,110,0.371);--k:dza1;--d:27s}',
    '.dz-aura .a2{width:95vmax;height:85vmax;margin:-42.5vmax 0 0 -47.5vmax;--c:rgba(40,24,130,0.364);--k:dza2;--d:33s}',
    '.dz-aura .a3{width:70vmax;height:62vmax;margin:-31vmax 0 0 -35vmax;--c:rgba(112,74,176,0.154);--k:dza3;--d:23s}',
    '.dz-aura .a4{width:80vmax;height:70vmax;margin:-35vmax 0 0 -40vmax;--c:rgba(118,36,90,0.252);--k:dza4;--d:38s}',
    '.dz-aura .a5{width:60vmax;height:55vmax;margin:-27.5vmax 0 0 -30vmax;--c:rgba(50,38,146,0.266);--k:dza5;--d:29s}',
    '.dz-aura .a6{width:78vmax;height:68vmax;margin:-34vmax 0 0 -39vmax;--c:rgba(168,70,92,0.21);--k:dza6;--d:35s}',
    '@keyframes dza1{0%{transform:translate3d(30vw,-34vh,0) scale(.9)}50%{transform:translate3d(6vw,-6vh,0) scale(1.16)}100%{transform:translate3d(-28vw,24vh,0) scale(.96)}}',
    '@keyframes dza2{0%{transform:translate3d(-34vw,30vh,0) scale(1.08)}50%{transform:translate3d(-4vw,2vh,0) scale(.88)}100%{transform:translate3d(30vw,-28vh,0) scale(1.18)}}',
    '@keyframes dza3{0%{transform:translate3d(-14vw,-38vh,0) scale(.85)}50%{transform:translate3d(22vw,8vh,0) scale(1.22)}100%{transform:translate3d(-8vw,38vh,0) scale(.94)}}',
    '@keyframes dza4{0%{transform:translate3d(34vw,38vh,0) scale(1)}50%{transform:translate3d(-16vw,-4vh,0) scale(1.18)}100%{transform:translate3d(-36vw,-34vh,0) scale(.9)}}',
    '@keyframes dza5{0%{transform:translate3d(-30vw,-10vh,0) scale(1.1)}50%{transform:translate3d(26vw,-30vh,0) scale(.86)}100%{transform:translate3d(8vw,36vh,0) scale(1.14)}}',
    '@keyframes dza6{0%{transform:translate3d(10vw,40vh,0) scale(.92)}50%{transform:translate3d(-24vw,12vh,0) scale(1.2)}100%{transform:translate3d(28vw,-20vh,0) scale(1)}}',
    '@media(prefers-reduced-motion:reduce){.dz-aura i{animation:none}}'
  ].join('\n');

  function init() {
    if (document.querySelector('.dz-aura')) return;
    var st = document.createElement('style'); st.id = 'dzAuraCss'; st.textContent = css;
    document.head.appendChild(st);
    var a = document.createElement('div'); a.className = 'dz-aura'; a.setAttribute('aria-hidden', 'true');
    a.innerHTML = '<i class="a1"></i><i class="a2"></i><i class="a3"></i><i class="a4"></i><i class="a5"></i><i class="a6"></i>';
    document.body.insertBefore(a, document.body.firstChild);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
